import { createStore } from 'vuex';
import NProgress from 'nprogress'//引入nprogress
import {storage} from '../utils/utils'

export default createStore({
    //存储数据
    state: {
		token: storage.get('token') ? storage.get('token') : '',
		userInfo: storage.get('userInfo') ? storage.get('userInfo') : null,
        homeData: storage.get('homeData') ? storage.get('homeData') : null,
        currentMenu: null,
        tabsList: [
            {
                path: '/',
                name: 'home',
                label: '首页',
                icon: 'home'
            }
        ],
        breadList: [] 
    },
	getters: {
		isLogin(state){
			return !!state.token
		},
    },
    //调用方法
    mutations: {
        // collapseMenu(state) {
        //     state.isCollapse = !state.isCollapse
        // },
        //选择标签 选择面包屑
        selectMenu(state, val) {
            if (val.name === 'home') {
                state.currentMenu = null
            }
            else{
                // console.log(val.name)
                let tabs = []
                state.tabsList.forEach((c)=>{
                    tabs.push(c.name)
                })
                if(tabs.indexOf(val.name) === -1){
                    NProgress.start()
                }
                state.currentMenu = val
                //如果等于-1说明tabsList不存在那么插入，否则什么都不做
                let result = state.tabsList.findIndex(item => item.name === val.name)
                result === -1 ? state.tabsList.push(val) : ''
            }
            // val.name === 'home' ? (state.currentMenu = null) : (state.currentMenu = val)
        },
        //关闭标签
        closeTab(state, val) {
            let result = state.tabsList.findIndex(item => item.name === val.name)
            state.tabsList.splice(result, 1)
        },
        setBreadList(state, list){
            state.breadList = list
        },
        
		SET_TOKEN(state, data){
			if(data.token){
				state.token = data.token
				storage.set('token', state.token)				
			}
			if(data.userInfo){
				state.userInfo = data.userInfo
				storage.set('userInfo', state.userInfo)
			}
		},
		EXIT(state){
			state.token = ''
			state.userInfo = null
			storage.remove('token')
			storage.remove('userInfo')
		},
        SIGNIN(state, dian){
            if(state.userInfo){
                let userInfo = state.userInfo
                userInfo.sign = 1
                userInfo.gold = dian
                storage.set('userInfo', userInfo)
            }
        },
        SET_GOLD(state, dian){
            if(state.userInfo){
                let userInfo = state.userInfo
                userInfo.gold = dian
                storage.set('userInfo', userInfo)
            }
        },
        SET_HomeData(state, data){
            state.homeData = data
            storage.set('homeData', data)
        }
    },
    actions: {}

})